<template>
  <div class="container  d-flex justify-center mb-16" v-if="post">
    <div class="max-w-3xl w-full">
      <div
        class="title flex-grow-0 font-weight-medium grey--text text--darken-4 ellipsis-2 mb-5 mt-10"
      >
        <div v-html="post.title"></div>
      </div>
      <v-responsive :aspect-ratio="2 / 1" class="flex-grow-0">
        <v-img
          class="w-full h-full object-cover"
          :src="$connection + post.photoURL"
          :alt="post.title"
        >
          <template v-slot:placeholder>
            <v-row
              class="fill-height ma-0 grey lighten-2"
              align="center"
              justify="center"
            >
              <v-progress-circular
                indeterminate
                color="grey lighten-5"
              ></v-progress-circular>
            </v-row> </template
        ></v-img>
      </v-responsive>
      <div
        class="flex-grow-0 align-center pb-2 text-subtitle-2 grey--text text--darken-2 d-flex mt-3"
      >
        <div>{{ upperFirst(post.info) }}</div>
        <v-spacer></v-spacer>
        <div>
          <v-icon class="mr-1" color="primary" small>mdi-eye</v-icon
          >{{ post.views }}
        </div>
      </div>
      <div class="flex-nowrap d-flex flex-column pb-3">
        <div class="grey--text flex-grow-0 text-caption my-2 font-weight-bold">
          {{ $moment(post.created_at).format("DD.MM.YYYY") }}
        </div>
      </div>
      <div class="text-subtitle-1">
        <blockquote
          style="text-align: justify"
          v-html="post.text.replace(/\n/g, '<br/>')"
        ></blockquote>
      </div>
      <v-divider></v-divider>

      <v-row v-if="post.photoURLs.length > 0">
        <v-col cols="12" class="title">
          {{ $t("image_galerie") }}
        </v-col>
        <v-dialog
          v-model="dialog"
          :width="$vuetify.breakpoint.mobile ? '90%' : '50%'"
          class="overflow-hidden w-full"
          style="max-height: 70%"
        >
          <v-img
            class="overflow-hidden"
            contain
            :src="$connection + fullscreenImageSrc"
          ></v-img>
        </v-dialog>
        <v-col
          v-for="(url, i) in post.photoURLs"
          :key="i"
          class="d-flex child-flex"
          cols="6"
          sm="4"
          lg="3"
        >
          <v-hover v-slot="{ hover }">
            <v-card
              @dblclick="
                fullscreenImageSrc = url;
                dialog = true;
              "
              tile
              :elevation="hover ? 12 : 2"
              :class="{ 'on-hover': hover }"
            >
              <v-img
                :src="$connection + url"
                aspect-ratio="1"
                class="grey lighten-2"
              >
                <template v-slot:placeholder>
                  <v-row
                    class="fill-height ma-0"
                    align="center"
                    justify="center"
                  >
                    <v-progress-circular
                      indeterminate
                      color="grey lighten-5"
                    ></v-progress-circular>
                  </v-row>
                </template>
              </v-img>
            </v-card>
          </v-hover>
        </v-col>
      </v-row>
      <v-divider></v-divider>
      <v-row>
        <v-col cols="12" class="title d-flex">
          {{ $t("author") }}
          <v-spacer></v-spacer>
          <v-btn
            :disabled="!val"
            fab
            small
            text
            v-for="(val, key, i) in post.social_media"
            :key="i"
            class="ml-3"
            v-show="val"
            :href="val"
          >
            <v-icon :color="config.icons.social_media[key].color">{{
              config.icons.social_media[key].icon
            }}</v-icon>
          </v-btn>
        </v-col>
        <v-col cols="12" class="mt-n6">
          <BlogPostInfo
          :post="post"
            :article_count="post.article_number"
            class="flex-grow-1"
            :social_media="post.social_media"
            :author="post.owner"
          />
        </v-col>
      </v-row>
    <v-btn text @click="$router.go(-1)" color="primary" class="px-0 mt-5">
      <v-icon>mdi-chevron-left</v-icon>
      {{ $t("back") }}
    </v-btn>
    </div>

    <!-- {{ post }} -->
  </div>
</template>

<script>
import BlogPostInfo from "@/components/BlogPostInfo";
export default {
  components: { BlogPostInfo },
  data() {
    return {
      dialog: false,
      fullscreenImageSrc: "",
    };
  },
  methods: {
    getBlogPostById() {
      this.$store.dispatch("publicApi/getBlogPostById", {
        id: this.$route.params.id,
      });
    },
    upperFirst(word) {
      return word.charAt(0).toUpperCase() + word.substring(1)
    }
  },
  computed: {
    post() {
      return this.$store.getters["publicApi/getPost"];
    },
    config() {
      return this.$store.getters["config/getConfig"];
    },
  },
  created() {
    this.getBlogPostById();
  },
};
</script>

<style lang="scss" scoped>
.v-card {
  transition: all 0.3s ease-in-out;
}

.v-card:not(.on-hover) {
  opacity: 0.8;
}
</style>